<template>
  <div>
    <v-select
      :name="name"
      :label="label"
      :class="errorClass"
      :items="items"
      :error-messages="errorMessages"
      :disabled="disabled"
      v-model="_value"
      item-value="value"
      item-text="text"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "select-input",

  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: [Boolean],
      default: false
    },
    value: {
      type: [String, Number]
    },
    items: {
      type: Array,
      required: false,
    },
    vErrors: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    }
  },

  computed: {
    errorMessages() {
      return this.vErrors.collect(this.name)
    },
    errorClass() {
      return this.form.errors.has(this.name) && 'input-group--error error--text'
    },
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
        this.$emit('input', value)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/SelectInput.vue